import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { API_URL } from 'common/constants/sm-constants';
import { environment } from 'src/environments/environment';
import { StudentListDataService } from 'common/services/data-services/admin/groups/student-list-data.service';
import { GroupsListingModel } from 'common/models/page-models/groups/groups-grid-model';
import { GroupDetailListingModel } from 'common/models/page-models/groups/group-details/group-detail-grid-model';
import { GroupDetailModel } from 'common/models/page-models/groups/group-details/group-detail-model';
import { GroupDetailsGridMetaModel } from 'common/models/page-models/groups/group-details/groups-detail-grid-meta-model';


@Injectable({
    providedIn: 'root'
})
export class StudentListWidgetService extends GridWidgetService<GroupDetailModel, GroupDetailListingModel> {
    constructor(protected override ds: StudentListDataService, protected systemService: SystemService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new GroupDetailsGridMetaModel().getMetaModel();
        return meta;
    }

    async getFilterOptions(filterMetaModel: any) {
        const urlList = [{ url: environment.apiUrl + API_URL.getGroupBatchList, payload: '' }];
        await this.ds.apiCallFromMultipleAPIforGrid(urlList).then((data) => {
            const batches = (data[0]).details;
            filterMetaModel.properties.batch_id.options = batches;
        })
    }

    override prepareMetaModel(dataModel: GroupsListingModel, metaModel: GroupDetailsGridMetaModel, routeData: WidgetModel): Promise<GroupDetailsGridMetaModel> {
        return new Promise<GroupDetailsGridMetaModel>((resolve, reject) => {
            metaModel.pageTitle = dataModel['id'] !== 0 ?  'Update Group' : 'Add Group';
            routeData.transferData['formData'].id = routeData.transferData['formData'].hasOwnProperty('group_id') ? routeData.transferData['formData'].group_id:routeData.transferData['formData'].id ;
            if(routeData.transferData['formData'].id !== 0) {
                routeData.transferData['formMeta'].properties.batch_id.readOnly = true;
            } else {
                routeData.transferData['formMeta'].properties.batch_id.readOnly = false;
            }
            resolve(metaModel);
        });
    }

}